import { Content, ContentProps } from "./components/Content"
import { Dossier, DossierProps } from "./components/Dossier"
import React from "react"

export const EmployeeProfileSidebar: React.FC<DossierProps & ContentProps> = ({
  onClose,
  isOpen,
  hasDrawer,
  size,
  ...props
}) => {
  return (
    <Dossier
      onClose={onClose}
      isOpen={isOpen}
      hasDrawer={hasDrawer}
      size={size}
    >
      <Content {...props} />
    </Dossier>
  )
}

export default EmployeeProfileSidebar
